import React from 'react';
import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';
import filterBlackList from '@laigu/utils/filterBlackList';

import style from './index.less';

const MessageProductCard = props => {
  const { data = {}, size } = props;
  const { pic_url, title, description, product_url, sales_count } = data;
  const picStyle = {
    background: `url(${removeHTMLScript(pic_url)}) no-repeat center/cover border-box border-box`
  };
  const safeUrl = filterBlackList(removeHTMLScript(product_url));

  return (
    <div className={`${size || 'large'} ${style['product-card']}`}>
      <a target='_blank' rel='noopener noreferrer' href={safeUrl}>
        <div style={picStyle} />
      </a>
      <div className='content'>
        <div className='title' title={title}>
          {title}
        </div>
        <div className='desc' title={description}>
          {description}
        </div>
        <div className='option'>
          {sales_count >= 0 ? `销量: ${sales_count}` : null}
          {safeUrl && (
            <a href={safeUrl} target='_blank' rel='noopener noreferrer'>
              {'查看详情'}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageProductCard;
